package org.zq.astrock_ai.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import org.zq.astrock_ai.theme.BinanceColors

@Composable
fun GlassPanel(
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit,
) {
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(12.dp))
            .background(BinanceColors.Card.copy(alpha = 0.95f))
            .border(1.dp, BinanceColors.Hairline, RoundedCornerShape(12.dp))
            .padding(0.dp),
        content = content,
    )
}

@Composable
fun GradientBorderPanel(
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit,
) {
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(12.dp))
            .background(BinanceColors.Card)
            .border(1.dp, BinanceColors.Yellow.copy(alpha = 0.2f), RoundedCornerShape(12.dp)),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(20.dp),
            content = content,
        )
    }
}
